<template>
  <DiseaseAnalysisComponent :properties="properties"></DiseaseAnalysisComponent>
</template>

<script>
import core from "@/core";
import CodeService from "@/services/code/code.service";
import DiseaseAnalysisComponent from "@/components/analysis/DiseaseAnalysisComponent";
import MixinStorage from "@/mixins/storage";

export default {
  name: "TomatoDiseaseAnalysis",
  components: {
    DiseaseAnalysisComponent,
  },
  mixins: [MixinStorage("disease")],
  data() {
    return {
      crop: "tomato",
      properties: {
        cropCode: null,
      },
    };
  },
  mounted() {
    this.$nextTick(async () => {
      core.loader.hide();
      await this.storageWait();
      this.changeCrop(this.crop);
    });
  },
  methods: {
    async changeCrop(crop) {
      this.properties.cropCode = await CodeService.findCropCodeByEnName(crop);
      const items = this.getStorageItems();
      items.crop = crop;
      this.saveStorageItems();
    },
  },
};
</script>
